module.exports = __webpack_public_path__ + "img/mail_contacto.7b7b720f.jpg";